import {defineStore} from 'pinia';
import {QueryCommand} from "xmgoing-server";
import {getFilterJson} from "@/gateway-main/components/hooks/useDatasHooks";
import {
  initErrorDealStr,
  initParamsByParamsDealStr,
  initParamsByQueryParams,
  initSuccessDealDealStr
} from "@/store/utils/dataSourceUtils";

/**
 * 删除操作
 * @param recordId
 * @param backFun
 */
export const removeDs = async function (recordId, backFun) {
  const params = {
    ids:recordId
  }
  const queryCommand = new QueryCommand({
    url: '/api/go-lcc/metaDatasource/remove',
    method: 'POST'
  })
  return queryCommand.executeQueryPromise({params}).then((res) => {
    backFun&&backFun(res);
  })
}

export interface ISourceObj {
  apiType: string;
  id:string;
  isAutoCache: boolean;
  queryParams: Array<any>;
  queryCode: string;
  isAutoQuery: boolean;
  queryUrl: string;
  methods: string;
  timeOut: number;
  headers: Array<any>;
  remark: string;
}

interface DataSourceState {
  connectorUrlHeader: any,
  dataLoadFlags: any,
  dataListCache: any,
  datasourceList: Array<ISourceObj>
}



export const useDataSourceStore = defineStore({
  id: 'dataSourceStore',
  state: (): DataSourceState => ({
    connectorUrlHeader: '',
    datasourceList: [],//数据配置集合
    dataLoadFlags: {},//表示哪些请求已经组装数据完成
    dataListCache: {}//数据信息缓存
  }),
  getters: {},
  actions: {
    startPageHeart(backFun){
      setTimeout(()=>{
        var queryCommand = new QueryCommand({
          url: `/api/pe-portal/account/getCurAccountInfo`,
          method: "POST",
          showTip: false,
        });
        //执行查询操作
        let successFun = () => {
          backFun&&backFun();
        };
        //设置不显示错误flag
        queryCommand.setHasErrorFlag(false);
        queryCommand.executeQuery({ successFun });
      },600000)
    },
    getDatasourceList(){
      return this.datasourceList;
    },
    //修改操作
    modDataSourceObj(sourceObj, oldQueryCode, pageModelsStore) {
      const index = this.datasourceList.findIndex((itemDb) => {
        return itemDb.queryCode === oldQueryCode;
      });
      if (index >= 0) {
        this.datasourceList[index] = {...sourceObj};
        this.queryData(sourceObj, pageModelsStore);
      }
    },
    //将数据源信息追加到列表中
    addDataSourceList(sourceObj: ISourceObj, pageModelsStore) {
      const index = this.datasourceList.findIndex((itemDb) => {
        return itemDb.queryCode === sourceObj.queryCode;
      });
      //如果对象存在 则应该修改
      if (index >= 0) {
        this.datasourceList[index] = {...sourceObj};
        this.queryData(sourceObj, pageModelsStore);
      } else {
        // 新增操作
        this.datasourceList.push(unref(sourceObj));
        this.queryData(sourceObj, pageModelsStore);
      }
    },
    //平台api的调用
    _queryDataByCommonApi({sourceObj, queryUrl, pageModelsStore, backFun,errorFun,extendParams={}}) {
      const {filter, filterRelVal} = unref(sourceObj);
      const filterStr = JSON.stringify(getFilterJson(filter, filterRelVal, pageModelsStore));
      if (sourceObj == null) {
        return;
      }
      if (this.dataLoadFlags[sourceObj.queryCode]) {
        backFun && backFun(this.dataListCache[sourceObj.queryCode]);
        return;
      }

      this.dataLoadFlags[sourceObj.queryCode] = false;
      let params: any = {};
      if (filterStr&&(filterStr+'').trim()!=='{}') {
        params.formula = filterStr;
      }
      //定义的查询参数集合
      if (sourceObj.queryParams) {
        initParamsByQueryParams(sourceObj.queryParams, params, pageModelsStore);
        let requiredFlag=true;
        sourceObj.queryParams.forEach((itemDb)=>{
          //如果参数必须存在 才继续
          if(itemDb.required&&(params[itemDb.key]==null||params[itemDb.key]==="")){
            requiredFlag=false;
          }
        })
        if(!requiredFlag){
          return;
        }
      }
      //定义扩展查询参数
      if (extendParams&&Array.isArray(extendParams)) {
        initParamsByQueryParams(extendParams, params, pageModelsStore);
      }else{
        params={...params,...extendParams}
      }
      //如果存在处理前的函数
      if (sourceObj.paramsDeal) {
       try {
         const backParams = initParamsByParamsDealStr(params, sourceObj.paramsDeal);
         if (backParams != null && typeof (backParams) === 'object') {
           //将返回回来的参数 给查询使用
           params = backParams;
         }
       }catch (e){
         console.error(e);
       }
      }
      const queryCommnad = new QueryCommand({url: queryUrl,showTip:false, method: sourceObj.methods});
      if (sourceObj.headers) {
        queryCommnad.setHeaders(sourceObj.headers);
      }
      queryCommnad.executeQueryPromise({params}).then((res) => {
        if (sourceObj.successDeal) {
          const backRes = initSuccessDealDealStr(res, sourceObj.successDeal,pageModelsStore);
          if (backRes != null && typeof (backRes) === 'object') {
            //将返回回来的参数 给查询使用
            res = backRes;
          }
        }
        this.dataLoadFlags[sourceObj.queryCode] = true;
        this.dataListCache[sourceObj.queryCode] = res || [];
        backFun && backFun({res});
      }, (error) => {
        if (sourceObj.errorDeal) {
          initErrorDealStr(error, sourceObj.errorDeal);
        }
        errorFun&&errorFun(error);
      });
    },
    /**
     * 查询根据后端函数
     * @param sourceObj
     * @param pageModelsStore
     * @param backFun
     */
    _queryDataByBackFun({sourceObj, pageModelsStore, backFun}) {
      console.log(pageModelsStore, "------pageModelsStore")
      window.xm.invokeService(sourceObj.queryCode, {}, (res) => {
        this.dataListCache[sourceObj.queryCode] = res || [];
        backFun && backFun({res});
      });
    },
    /**
     * 查询根据集成服务地址 需要进行一次查询 再进行调用
     * @param sourceObj
     * @param pageModelsStore
     * @param backFun
     */
    _queryDataByConnector({sourceObj, pageModelsStore, backFun,errorFun}) {
      //判断是否已经缓存了
      if (this.connectorUrlHeader) {
        this._queryDataByCommonApi({
          sourceObj,
          queryUrl: this.connectorUrlHeader + sourceObj.queryUrl,
          pageModelsStore,
          errorFun,
          backFun
        })
      } else {
        const queryCommnad = new QueryCommand({url: "/api/go-fks/ipaas/endpoint/gatewayHost",showTip:false, method: "GET"});
        queryCommnad.executeQueryPromise({params: {}}).then((res) => {
          this.connectorUrlHeader = res;
          this._queryDataByCommonApi({sourceObj, queryUrl: res + sourceObj.queryUrl, pageModelsStore, errorFun,backFun})
        },(msg)=>{
            console.error(msg,"=============");
          errorFun&&errorFun(msg);
        });
      }
    },
    //查询数据
    queryData(sourceObj, pageModelsStore, backFun?: any,errorFun?:any,extendParams?:any) {
      //如果是集成平台API 则需要特殊处理
      if (sourceObj.connectorId) {
        this._queryDataByConnector({sourceObj, pageModelsStore, backFun,errorFun});
        return;
      } else {
        if (sourceObj.backFunId) {
          this._queryDataByBackFun({sourceObj, pageModelsStore, backFun});
          return;
        } else {
          this._queryDataByCommonApi({sourceObj, queryUrl: sourceObj.queryUrl, pageModelsStore, backFun,extendParams,errorFun})
        }
      }
    },
    //将配置信息设置到store里面
    setDataSourceList(dsAry: Array<ISourceObj>, pageModelsStore) {
      this.dataLoadFlags = {};
      if (dsAry && dsAry.length > 0) {
        this.datasourceList = dsAry;
        this._loadDataSourceDatas(pageModelsStore);
      }
    },
    //查询界面对应的数据集合
    _loadDataSourceDatas(pageModelsStore) {
      this.dataListCache = {};
      //将需要自动加载的集合找出来 然后触发查询操作
      this.datasourceList.filter((itemSource) => {
        return itemSource.isAutoQuery;
      }).forEach((sourceDb:any) => {
        if(sourceDb.isPageComplete){
            setTimeout(()=>{
              this.queryData(sourceDb, pageModelsStore);
            },300)
        }else{
          this.queryData(sourceDb, pageModelsStore);
        }
      })
    },
    /**
     * 根据查询编码获取查询信息
     * @param queryCode
     * @param backFun
     */
    getDatasByQueryCode(queryCode, pageModelsStore, backFun,errorFun=()=>{},extendParams={}) {
      //根据编码获取
      if (unref(this.dataLoadFlags)[queryCode]) {
        const res = this.dataListCache[queryCode];
        backFun && backFun({res},true);
      } else {
        const findItem = this.datasourceList.filter((itemDb) => {
          return itemDb.queryCode === queryCode;
        })[0];
        if(findItem){
          this.queryData(findItem, pageModelsStore, ({res}) => {
            backFun && backFun({res},true);
          },(res)=>{
            errorFun&&errorFun(res);
          },extendParams)
        }
      }
    },
    //删除缓存数据
    removeCacheByCode(queryCode) {
      unref(this.dataLoadFlags)[queryCode] = false;
       this.dataListCache[queryCode]=null;
    },
    clearAllCache(){
      this.dataListCache={};
      this.dataLoadFlags={};
      this.datasourceList=[];
    },
    /**
     * 删除相应的数据源信息
     * @param index
     */
    removeList(index) {
      const delItem: Array<ISourceObj> = this.datasourceList.splice(index, 1);
      if (delItem[0]) {
        if(delItem[0].id){
          removeDs(delItem[0].id,()=>{
            delete this.dataListCache[delItem[0].queryCode];
          });
        }else{
          delete this.dataListCache[delItem[0].queryCode];
        }

      }
    }
  },
});
